var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('v-card',{staticClass:"rounded-lg",attrs:{"outlined":""}},[_c('iframe',{staticClass:"pt-3",staticStyle:{"border":"none"},attrs:{"height":_vm.$vuetify.breakpoint.mdAndUp ? '250px' : '550px',"width":"100%","src":_vm.urlGamification}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }